import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  flex-grow: 1;
`;

export const BlendModesWrap = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`;

export const ColorWrap = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
`;

export const Color = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${({ color }) => color};
  margin-right: 4px;
  padding: 2px;

  ${({ isActive }) =>
    isActive
      ? css`
          border: 2px solid ${({ theme }) => theme.palette.global02};
          padding: 0;
        `
      : null};
`;

export const Title = styled.div`
  padding-bottom: 12px;
  ${({ theme }) => theme.textStyles.heading03global02};
`;

export const ResolutionWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Input = styled.input`
  width: 48px;
  height: 20px;
`;

export const ResolutionSpacer = styled.span`
  margin-left: 8px;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const IconButton = styled.img`
  margin-left: 8px;
  margin-right: 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export default null;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/ImageControls/ImageControls.styled.js